import { defineMessages } from 'react-intl';

export const messages: {
	timeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	timeLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.local-time-input.preview.time-label',
		defaultMessage: 'Time',
		description: 'Fallback label for the local time input field in preview mode',
	},
});
